// extracted by mini-css-extract-plugin
export default {"wrapper":"UserDetails-module__wrapper--fe8a0","avatar":"UserDetails-module__avatar--bd9a2","details":"UserDetails-module__details--b040b","name":"UserDetails-module__name--e8eaa"};